// Content shared across every social advert format.
// Voice matches the SalesLanding page: warm, confident, cheeky UK English.

export const socialAdvert = {
  eyebrow: "Messy Pups · Passive income for venues",
  headline: "Your venue.\nTheir dog.\nYour income.",
  subheadline:
    "Add a self-service dog wash and turn dog-owning customers into a hands-off revenue stream.",
  spaceChip: "Fits in ~2m²",

  // Net income per month (at £10/wash, ~£0.90 running cost, 30 days).
  scenarios: [
    { d: 5, net: "£1,365" },
    { d: 10, net: "£2,730" },
    { d: 15, net: "£4,095" },
  ],

  contactEmail: "sarah@messypups.co.uk",
  website: "messypups.co.uk",
  tagline: "Play. Wash. Repeat.",
};
